import { lazy } from 'react';

export const Notifications = lazy(() => import('./Notifications.component'));
